import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import ToolsGeneralContent from '@v2/pages/machines/modules/now/components/Tools/components/ToolsGeneralContent';
import { connect } from 'react-redux';
import { PANEL_VIEW_MODE_WIDTH, SCREEN_PADDING_HORIZONTAL_FOR_ITEM } from '@v2/pages/common/constants/base.constants';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { isWeb } from '@helpers';

interface NCFileDetailsToolsProps {}

const NCFileDetailsToolsComponent: FC<NCFileDetailsToolsProps> = ({
  clearTools,
  getNCFileById,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  toolsLoaded,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  const { refetchTools } = useNCFileDetails({
    clearTools,
    getNCFileById,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.tool}>
      <View style={{ flex: 1, paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}>
        <ToolsGeneralContent
          maxDetailsWidth={PANEL_VIEW_MODE_WIDTH}
          loading={!toolsLoaded}
          bg={!isWeb ? 'Background/Light/Field on Panel' : 'Background/Light/Field'}
          refetchTools={refetchTools}
        />
      </View>
    </DetailsPageWrapper>
  );
};

const NCFileDetailsTools = connect(({ clampingTools: { loaded } }) => ({ toolsLoaded: loaded }), {
  clearTools,
  getNCFileById,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsToolsComponent);

export { NCFileDetailsTools };
